import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  scrollContainer: {
    // overflowY: "hidden",
    // whiteSpace: "nowrap",
    // msOverflowStyle: "none",
    // scrollbarWidth: "none",
    padding:"30px 24px 0px 24px",
    // "&::-webkit-scrollbar": {
    //   display: "none",
    // },
    // "&::-moz-scrollbars": {
    //   display: "none",
    // },
  },
  homeBanner: {
    maxWidth:"24%",
    "&:last-child": {
      "& img": {
        padding: 12,
      },
    },
  },
  bannerImg:{
    cursor: "pointer",
    width: "100%",
  },
  newTag:{
    width:"70px !important",
    top:"-10px",
    left:"10px  "
  },
  cardName:{
    textAlign:"center",
    color: "#212121",
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: "110%",
    letterSpacing: "0.5px",
  },
  "@media (max-width: 550px)": {
    homeBannerCard: {
      maxWidth: "550px",
      "& a": {
        width: "100%",
      },
      "& img": {
        width: "100%",
      },
    },
    newTag:{
      width:"60px !important",
      top:"-10px",
      left:"12px  "
    },
    homeBanner: {
    maxWidth:"24%",
      "& img": {
        cursor: "pointer",
        width: "100%",
        paddingRight: 0,
      },
      "&:last-child": {
        "& img": {
          padding: 10,
        },
      },
    },
    cardName: {
      fontSize:"12px",
      fontWeight:600,
    },
    mt4:{
      marginTop:"4px"
    },
    scrollContainer:{
      padding:"0px 6px"
    },
  },
  carouselBannerDiv: {
    padding:"8px 16px",
    maxWidth: "550px",
    minWidth: "328px",
    height: 150,
    "& img": {
      display: "block",
      width: "100%",
      height: "100%",
    },
  },

  flex: {
    display: "flex",
  },
  spaceBw: {
    justifyContent: "space-between",
  },
  justifyCenter: {
    justifyContent: "center",
  },
  alignCenter: {
    alignItems: "center",
  },
  relative: {
    position: "relative",
  },
  absolute: {
    position: "absolute",
  },
}));

export default style;
